const homepage = () => {
	if ($(".homepage").length) {
		$('.question').click(function () {
			console.log('clicked');
			$(this).toggleClass('active');
		});

		$('.multiple-items').slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			prevArrow: '<button type="button" class="slick-prev"></button>',
			nextArrow: '<button type="button" class="slick-next"></button>',
			arrows: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows: false
					},
				},
			]
		});

		const onChangeUrl = function () {
			const url = $(this).data("slug");
			if (!url) {
				window.location.href = `?#section-1`
			}
			else window.location.href = `?slug=${url}#section-1`
		}

		$(".category-list-menu").on("click", ".item", function () {
			onChangeUrl.bind(this)();
		});

		$(window).scroll(function() {
			const scroll = $(window).scrollTop();
			const headerHeight = $('.group-header').outerHeight() - 30;
			if (scroll >= headerHeight) {
				$('.header-app').addClass('active');
			} else {
				$('.header-app').removeClass('active');
			}
		});
	}
}

module.exports = homepage
